import s from './GigAssFooter.module.sass'
import { FC, useState, useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { updateMessageTemplate, toggleTemplateEditor } from '../../model/slice'

interface GigAssFooterProps {
  onOpenFoundMistake?: () => void
}

const GigAssFooter: FC<GigAssFooterProps> = ({ onOpenFoundMistake }) => {
  const dispatch = useAppDispatch()
  const messageTemplate = useAppSelector((state) => state.gigAssist.messageTemplate)
  const isTemplateEditorOpen = useAppSelector((state) => state.gigAssist.isTemplateEditorOpen)
  const [localTemplate, setLocalTemplate] = useState(messageTemplate)
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const isDev = window.location.search.indexOf('is_dev=true') > 0

  // синхронизируем локальное состояние с глобальным
  useEffect(() => {
    setLocalTemplate(messageTemplate)
  }, [messageTemplate])

  // функция для автоматического изменения размера textarea
  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
    }
  }

  // вызываем adjustTextareaHeight при изменении localTemplate
  useEffect(() => {
    if (isTemplateEditorOpen) {
      adjustTextareaHeight()
    }
  }, [localTemplate, isTemplateEditorOpen])

  const handleTemplateChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setLocalTemplate(e.target.value)
  }

  const handleTemplateSave = () => {
    dispatch(updateMessageTemplate(localTemplate))
    dispatch(toggleTemplateEditor())
  }

  const handleTemplateClear = () => {
    setLocalTemplate('{userMsg}')
  }

  const handleTemplateCancel = () => {
    setLocalTemplate(messageTemplate)
    dispatch(toggleTemplateEditor())
  }

  const handleTemplateToggle = () => {
    dispatch(toggleTemplateEditor())
  }

  // const IS_PROD = typeof window !== 'undefined' && window.document.location.host === 'www.afisha.ru'

  return (
    <footer className={s.footer}>
      <div className={s.gradient}></div>

      {/* редактор шаблона */}

      {/* {isTemplateEditorOpen ? (
        <>
          <FloatingPortal id='next-gig-assist-template-editor'>
            <div className={s.templateEditor}>
              <label htmlFor='templateInput' className={s.templateLabel}>
                <span>Редактируйте шаблон сообщения</span>
                <textarea
                  id='templateInput'
                  ref={textareaRef}
                  value={localTemplate}
                  onChange={handleTemplateChange}
                  placeholder='{userMsg}'
                  className={s.templateInput}
                />
              </label>

              <div className={s.templateActions}>
                <button onClick={handleTemplateSave} className={s.templateSaveBtn}>
                  Сохранить
                </button>

                <button onClick={handleTemplateClear} className={s.templateCancelBtn}>
                  Очистить
                </button>

                <button onClick={handleTemplateCancel} className={s.templateCancelBtn}>
                  Отменить
                </button>
              </div>
            </div>
          </FloatingPortal>
        </>
      ) : (
        <button onClick={handleTemplateToggle} className={s.templateToggleBtn}>
          <span className={s.templateToggleText}>temp & dev</span>
        </button>
      )} */}

      <button className={s.reportButton} onClick={onOpenFoundMistake}>
        <span className={s.reportButtonText}>Сообщить об ошибке</span>
      </button>
    </footer>
  )
}

export default GigAssFooter
